import { render, staticRenderFns } from "./LoanBalance.vue?vue&type=template&id=3a1d82f7"
import script from "./LoanBalance.vue?vue&type=script&lang=js"
export * from "./LoanBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports